export let SwitchRootDataAttributes = /*#__PURE__*/function (SwitchRootDataAttributes) {
  /**
   * Present when the switch is checked.
   */
  SwitchRootDataAttributes["checked"] = "data-checked";
  /**
   * Present when the switch is not checked.
   */
  SwitchRootDataAttributes["unchecked"] = "data-unchecked";
  /**
   * Present when the switch is disabled.
   */
  SwitchRootDataAttributes["disabled"] = "data-disabled";
  /**
   * Present when the switch is readonly.
   */
  SwitchRootDataAttributes["readonly"] = "data-readonly";
  /**
   * Present when the switch is required.
   */
  SwitchRootDataAttributes["required"] = "data-required";
  /**
   * Present when the switch is in a valid state (when wrapped in Field.Root).
   */
  SwitchRootDataAttributes["valid"] = "data-valid";
  /**
   * Present when the switch is in an invalid state (when wrapped in Field.Root).
   */
  SwitchRootDataAttributes["invalid"] = "data-invalid";
  /**
   * Present when the switch has been touched (when wrapped in Field.Root).
   */
  SwitchRootDataAttributes["touched"] = "data-touched";
  /**
   * Present when the switch's value has changed (when wrapped in Field.Root).
   */
  SwitchRootDataAttributes["dirty"] = "data-dirty";
  /**
   * Present when the switch is active (when wrapped in Field.Root).
   */
  SwitchRootDataAttributes["filled"] = "data-filled";
  /**
   * Present when the switch is focused (when wrapped in Field.Root).
   */
  SwitchRootDataAttributes["focused"] = "data-focused";
  return SwitchRootDataAttributes;
}({});